import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {useLocation} from 'react-router-dom';

import {isEmpty} from 'front-onceforall-core/dist/utils/arrays';

import {USER_REQUEST_TYPES} from '../../../utils/constant';

import OverlayMessage from '../../overlayMessage';
import LinkButtonView from '../../buttons/link';

import ListItem from './ListItem';
import Message from './Message';

function MandatesListView({mandates, loading, isCollectionMandate, broadcastMandateServiceAuthorized}) {
  const location = useLocation();
  const translationPath = isCollectionMandate ? 'collection' : 'broadcast';

  const getColumnsHead = () => (isCollectionMandate ? (
    <tr>
      <td><Translate value="mandate.list.subtype"/></td>
      <td><Translate value="mandate.list.thirdParty"/></td>
      <td><Translate value="mandate.list.creationDate"/></td>
    </tr>
  ) : (
    <tr>
      <td><Translate value="mandate.list.platform"/></td>
      <td><Translate value="mandate.list.creationDate"/></td>
    </tr>
  ));

  const displayOverlayMessage = () => (
    <OverlayMessage
      type="document"
      message={<Translate value="mandate.planUpgradable"/>}
      containerStyle={{height: '90%', marginTop: '100px', padding: '100px 45px 0 95px'}}
    >
      <LinkButtonView
        link={`${location.pathname}?contact=${USER_REQUEST_TYPES.MY_OFFER}`}
        buttonLabel={<Translate value="plan.actions.contactUs"/>}
      />
    </OverlayMessage>
  );

  const renderEmpty = () => <>
    <div className="table-without-result">
      <Translate value={`mandate.list.noResult.${translationPath}`}/>
    </div>
  </>;

  const renderList = () => (
    <table>
      <thead>
        {getColumnsHead()}
      </thead>
      <tbody>
        {mandates.map(mandate => (
          <ListItem
            key={`mandate-${mandate.id}`}
            mandate={mandate}
            isCollectionMandate={isCollectionMandate}
          />
        ))}
      </tbody>
    </table>
  );

  return (
    <>
      {!isCollectionMandate && !broadcastMandateServiceAuthorized && displayOverlayMessage()}
      <h1 className="mt-0">
        <Translate value={`organisationSetting.mandates.${translationPath}.title`}/>
        <span className="separator information">{mandates?.length || 0}</span>
      </h1>
      <div
        className="card"
        style={{position: 'relative'}}
      >
        {loading && <div className="loading-overlay"/>}
        <Message isCollectionMandate={isCollectionMandate}/>
        {isEmpty(mandates) ? renderEmpty() : renderList()}
      </div>
    </>
  );
}

MandatesListView.propTypes = {
  mandates: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  isCollectionMandate: PropTypes.bool.isRequired,
  broadcastMandateServiceAuthorized: PropTypes.bool
};

export default MandatesListView;
